import { render, staticRenderFns } from "./Diversification.html?vue&type=template&id=1d463ce1&scoped=true&"
import script from "./Diversification.js?vue&type=script&lang=js&"
export * from "./Diversification.js?vue&type=script&lang=js&"
import style0 from "./Diversification.scss?vue&type=style&index=0&id=1d463ce1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d463ce1",
  null
  
)

export default component.exports